<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_162_5088" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="1" width="12" height="12">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.16675 7.00002C1.16675 3.78002 3.78008 1.16669 7.00008 1.16669C10.2201 1.16669 12.8334 3.78002
      12.8334 7.00002C12.8334 10.22 10.2201 12.8334 7.00008 12.8334C3.78008 12.8334 1.16675 10.22 1.16675
      7.00002ZM5.83342 8.26585L9.67758 4.42169L10.5001 5.25002L5.83342 9.91669L3.50008 7.58335L4.32258 6.76085L5.83342 8.26585Z"
      fill="white"/>
    </mask>
    <g mask="url(#mask0_162_5088)">
    <rect width="14" height="14" :fill="cor" />
    </g>
    </svg>
</template>

<script>
export default {
 name: 'MySVGComponent',
 props: {
    cor: {
      type: String,
      default: '#ff0000 '
    }
  },
}
</script>

<style lang="scss" scoped>
svg {
  position: absolute;
  top: 27px;
  left: 15px;
}
</style>
